// src/LogoBar.js
// Top bar shown on every screen. Includes a global contact (student) search so
// staff can jump to any student's profile from anywhere in the app.
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { database, ref, onValue } from "./firebase";
import { Search } from "lucide-react";

export default function LogoBar() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    return onValue(ref(database, "students"), (snap) => {
      const val = snap.val() || {};
      const list = Object.entries(val)
        .filter(([, s]) => s && s.active !== false)
        .map(([id, s]) => {
          const ei = s.extraInfo || {};
          const name =
            `${s.firstName || ei.firstName || ""} ${s.lastName || ei.lastName || ""}`.trim() ||
            s.name || "";
          return { id, name, phone: ei.phone || ei.mobile || s.mobile || "" };
        })
        .filter((s) => s.name);
      setStudents(list);
    });
  }, []);

  const q = query.trim().toLowerCase();
  const matches = q.length >= 2
    ? students.filter((s) => s.name.toLowerCase().includes(q)).slice(0, 8)
    : [];

  const go = (id) => {
    navigate(`/students/${id}`);
    setQuery("");
    setOpen(false);
  };

  return (
    <div className="logo-bar" style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <img src="/ixl-logo.png" alt="iXL Logo" className="logo" />

      <div ref={boxRef} style={{ position: "relative", marginLeft: "auto", width: "100%", maxWidth: 320 }}>
        <Search size={15} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#9ca3af", pointerEvents: "none" }} />
        <input
          type="text"
          value={query}
          onChange={(e) => { setQuery(e.target.value); setOpen(e.target.value.trim().length >= 2); }}
          onFocus={() => setOpen(query.trim().length >= 2)}
          onBlur={() => setTimeout(() => setOpen(false), 180)}
          placeholder="Search contacts…"
          style={{
            width: "100%", padding: "8px 12px 8px 32px", fontSize: 14,
            border: "1px solid #d1d5db", borderRadius: 999, boxSizing: "border-box",
            background: "#f9fafb", outline: "none",
          }}
        />
        {open && matches.length > 0 && (
          <div style={{
            position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4,
            background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.14)", zIndex: 1000,
            maxHeight: 320, overflowY: "auto",
          }}>
            {matches.map((s) => (
              <div
                key={s.id}
                onMouseDown={() => go(s.id)}
                style={{ padding: "10px 14px", cursor: "pointer", borderBottom: "1px solid #f3f4f6" }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f3f4f6")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <div style={{ fontWeight: 500, fontSize: 14, color: "#1f2937" }}>{s.name}</div>
                {s.phone && <div style={{ fontSize: 12, color: "#9ca3af" }}>{s.phone}</div>}
              </div>
            ))}
          </div>
        )}
        {open && q.length >= 2 && matches.length === 0 && (
          <div style={{
            position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4,
            background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10,
            boxShadow: "0 8px 24px rgba(0,0,0,0.14)", zIndex: 1000,
            padding: "12px 14px", color: "#9ca3af", fontSize: 13,
          }}>
            No contacts found.
          </div>
        )}
      </div>
    </div>
  );
}
